import type { AppThunk } from '@core/core/store'
import { selectActiveProjectId } from '@core/core/store'

import { getProjectVelocityModelsApi } from '../../api'
import { velocityModelsSlice } from './velocityModelsSlice'

const { addVelocityModels } = velocityModelsSlice.actions

export const getVelocityModelsByActiveProject = (): AppThunk => async (dispatch, getState) => {
  const projectId = selectActiveProjectId(getState())
  try {
    const models = await getProjectVelocityModelsApi(projectId)
    dispatch(addVelocityModels({ projectId, models }))
  } catch (error) {
    console.log(error)
  }
}
